export interface Category {
  id: string;
  label: string;
  slug: string;
  icon: string;
  color: string;
  quizCount: number;
  image: string;
}

export const categories: Category[] = [
  {
    id: "rpg",
    label: "Roleplaying Game",
    slug: "rpg",
    icon: "ri-sword-line",
    color: "from-rose-400 to-orange-400",
    quizCount: 52,
    image: "https://public.readdy.ai/ai/img_res/22ff8f7cf1667b3db25de1035188c022.jpg",
  },
  {
    id: "sandbox",
    label: "Sandbox Game",
    slug: "sandbox",
    icon: "ri-gamepad-line",
    color: "from-teal-400 to-cyan-400",
    quizCount: 44,
    image: "https://readdy.ai/api/search-image?query=toca%20boca%20sandbox%20game%20cute%20colorful%20world%20building%20blocks%20characters%20happy%20bright%20kawaii%20illustration%20style%20clean%20white%20background%20teal%20and%20mint%20tones&width=600&height=400&seq=cat002&orientation=landscape",
  },
  {
    id: "action",
    label: "Action Game",
    slug: "action",
    icon: "ri-flashlight-line",
    color: "from-amber-400 to-yellow-300",
    quizCount: 29,
    image: "https://readdy.ai/api/search-image?query=action%20game%20characters%20dynamic%20poses%20superhero%20cartoon%20style%20bright%20yellow%20amber%20energy%20effects%20exciting%20vibrant%20illustration%20no%20blue%20no%20purple%20warm%20colors&width=600&height=400&seq=cat003&orientation=landscape",
  },
  {
    id: "entertainment",
    label: "Entertainment",
    slug: "entertainment",
    icon: "ri-star-smile-line",
    color: "from-pink-400 to-rose-400",
    quizCount: 68,
    image: "https://readdy.ai/api/search-image?query=entertainment%20pop%20culture%20fun%20celebrity%20stars%20glitter%20confetti%20party%20pink%20and%20rose%20tones%20bright%20cheerful%20kawaii%20illustration%20style%20happy%20girls%20teens&width=600&height=400&seq=cat004&orientation=landscape",
  },
  {
    id: "movies",
    label: "Movies",
    slug: "movies",
    icon: "ri-movie-2-line",
    color: "from-orange-400 to-amber-400",
    quizCount: 41,
    image: "https://readdy.ai/api/search-image?query=movies%20cinema%20film%20reel%20popcorn%20tickets%20disney%20pixar%20cartoon%20characters%20colorful%20orange%20amber%20warm%20tones%20bright%20cheerful%20illustration%20style&width=600&height=400&seq=cat005&orientation=landscape",
  },
  {
    id: "anime",
    label: "Anime",
    slug: "anime",
    icon: "ri-magic-line",
    color: "from-fuchsia-400 to-pink-400",
    quizCount: 55,
    image: "https://readdy.ai/api/search-image?query=anime%20manga%20art%20style%20cute%20chibi%20characters%20sakura%20blossom%20pastel%20pink%20fuchsia%20warm%20tones%20bright%20kawaii%20illustration%20japanese%20art%20no%20blue%20no%20purple&width=600&height=400&seq=cat006&orientation=landscape",
  },
  {
    id: "love",
    label: "Love & Horoscope",
    slug: "love",
    icon: "ri-heart-3-line",
    color: "from-rose-400 to-pink-300",
    quizCount: 61,
    image: "https://readdy.ai/api/search-image?query=love%20horoscope%20zodiac%20stars%20romantic%20kawaii%20art%20style%20warm%20rose%20pink%20gold%20tones%20bright%20cheerful%20illustration%20style%20hearts%20constellation%20celestial%20teen%20romance&width=600&height=400&seq=cat008&orientation=landscape",
  },
  {
    id: "animals",
    label: "Animals",
    slug: "animals",
    icon: "ri-bear-smile-line",
    color: "from-green-400 to-teal-400",
    quizCount: 33,
    image: "https://readdy.ai/api/search-image?query=cute%20cartoon%20animals%20forest%20friends%20bunny%20fox%20deer%20bear%20kawaii%20style%20bright%20green%20teal%20nature%20background%20soft%20pastel%20tones%20adorable%20characters&width=600&height=400&seq=cat007&orientation=landscape",
  },
];

export const trendingTags = [
  { id: "t1", label: "Avatar World", slug: "avatar-world", count: 18 },
  { id: "t2", label: "Toca Boca", slug: "toca-boca", count: 21 },
  { id: "t3", label: "Disney", slug: "disney", count: 24 },
  { id: "t4", label: "Roblox", slug: "roblox", count: 21 },
  { id: "t5", label: "Minecraft", slug: "minecraft", count: 22 },
  { id: "t6", label: "Horoscope", slug: "horoscope", count: 19 },
  { id: "t7", label: "Love & Friendship", slug: "love-friendship", count: 26 },
  { id: "t8", label: "Garten of Banban", slug: "garten-of-banban", count: 9 },
  { id: "t9", label: "My Little Pony", slug: "my-little-pony", count: 11 },
  { id: "t10", label: "Poppy Playtime", slug: "poppy-playtime", count: 14 },
  { id: "t11", label: "Encanto", slug: "encanto", count: 10 },
  { id: "t12", label: "Alphabet Lore", slug: "alphabet-lore", count: 8 },
];
